import React from 'react';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../context/useAppContext';
import { useHistory } from 'react-router-dom';
import { Card, Icon } from '@weezevent/nacre';

export default function Unavailable() {
    const [{ event, organization }] = useAppContext();
    const history = useHistory();
    const { t } = useTranslation();

    const handleClick = React.useCallback(() => {
        history.push(`/ticket/O${organization.id}/E${event.id}/settings/rates`);
    }, [history, organization, event]);

    return (
        <Card.EmptyState
            title={t('attendees.addAttendees.noRates')}
            subtitle={t('attendees.addAttendees.noRatesSubtitle')}
            icon={<Icon name="list" />}
            labelButton={t('attendees.addAttendees.createTarif')}
            onClick={handleClick}
        />
    );
}
